import { observeElement } from '@/utils/scrollReveal'

export const revealDirective = {
  mounted(el, binding) {
    const value = binding.value ?? {}
    const variant = binding.arg || value.variant || 'up'
    const delay = value.delay ?? 0
    observeElement(el, { variant, delay })
  },
}
